module.exports = {
  "country": "IT",
  "artist": "Toto Cutugno",
  "song": "Insieme: 1992",
  "year": "1990",
  "place": "1",
  "spotify": "7zfUnbwfHXq3dwIYqhU4Mo"
};